export * from './BaseEntity';
export * from './company';
export * from './trip';
export * from './basic-types';
export * from './description';
export * from './integration';
export * from './report';
export * from './fleet';
export * from './account';
export * from './module';

/**
 * Creates an array of the given type, by using the constructor on each element in a JSON array.
 */
export function fromJsonArray<T>(constructor: { new (json: any): T }, json: any): T[] {
    return json != null && Array.isArray(json) ? json.map((element: any) => new constructor(element)) : [];
}

/**
 * Creates an array of the given type, by using the given provider on each element in a JSON array.
 */
export function fromJsonArrayWith<T>(provider: (json: any) => T | undefined, json: any): T[] {
    return json != null && Array.isArray(json) ? json.map((element: any) => provider(element)!) : [];
}
